import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./radar.css";
import useInterval from "./interval";

const Radar1 = () => {
  const [radar_minutes, setRadar_minutes] = React.useState({
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: "",
    7: "",
    8: "",
    9: "",
    10: "",
  });
  React.useEffect(() => {
    fetch(
      "http://222.239.231.149:8080/dashboard/yeongam/data/radarwind__minutes.json"
    )
      .then((res) => res.json())
      .then((data) => {
        setRadar_minutes(data);
      });
  }, []);
  useInterval(() => {
    fetch(
      "http://222.239.231.149:8080/dashboard/yeongam/data/radarwind__minutes.json"
    )
      .then((res) => res.json())
      .then((data) => {
        setRadar_minutes(data);
      });
  }, 60000);

  const customSlider = React.createRef();

  const [sliderSettings] = useState({
    dots: false, // 페이지네이션 X
    fade: true, // 슬라이드 종류 fade slide
    slidesToShow: 1, // 표출은 몇장씩 할지
    slidesToScroll: 1, // 슬라이드가 몇장씩 넘어갈지
    speed: false, // 슬라이드 애니메이션 속도
    autoplay: true, // 사이트 접속시 자동재생
    autoplaySpeed: 2000, // 슬라이드 속도
    arrows: false, // 화살표 X
    pauseOnHover: false,
  });
  const slidePlay = () => {
    customSlider.current.slickPlay();
  };

  const slidePause = () => {
    customSlider.current.slickPause();
  };

  const [play, pause] = React.useState(false);

  return (
    <div className="radabox">
      <div className="title">
        <span className="avititle">위성영상(적외영상)</span>
        <div
          onClick={() => {
            pause((e) => !e);
          }}
        >
          {play ? (
            <img
              className="pauseBtn"
              src={process.env.PUBLIC_URL + "/img/play_white.png"}
              alt="play"
              onClick={slidePlay}
            />
          ) : (
            <img
              className="playBtn"
              src={process.env.PUBLIC_URL + "/img/pause_white.png"}
              alt="pause"
              onClick={slidePause}
            />
          )}
        </div>
      </div>
      <Slider className="slider" {...sliderSettings} ref={customSlider}>
        <div>
          <div className="updatetime">
            <span>{radar_minutes["1"]}</span>
          </div>
          <img
            className="radarimg"
            style={{ display: "inline-block" }}
            src={process.env.PUBLIC_URL + "/satellite/satellite0.png"}
            alt="위성사진10"
          />
        </div>
        <div>
          <div className="updatetime">
            <span>{radar_minutes["10"]}</span>
          </div>
          <img
            className="radarimg"
            style={{ display: "inline-block" }}
            src={process.env.PUBLIC_URL + "/satellite/satellite9.png"}
            alt="위성사진1"
          />
        </div>
        <div>
          <div className="updatetime">
            <span>{radar_minutes["9"]}</span>
          </div>
          <img
            className="radarimg"
            style={{ display: "inline-block" }}
            src={process.env.PUBLIC_URL + "/satellite/satellite8.png"}
            alt="위성사진2"
          />
        </div>
        <div>
          <div className="updatetime">
            <span>{radar_minutes["8"]}</span>
          </div>
          <img
            className="radarimg"
            style={{ display: "inline-block" }}
            src={process.env.PUBLIC_URL + "/satellite/satellite7.png"}
            alt="위성사진3"
          />
        </div>
        <div>
          <div className="updatetime">
            <span>{radar_minutes["7"]}</span>
          </div>
          <img
            className="radarimg"
            style={{ display: "inline-block" }}
            src={process.env.PUBLIC_URL + "/satellite/satellite6.png"}
            alt="위성사진4"
          />
        </div>
        <div>
          <div className="updatetime">
            <span>{radar_minutes["6"]}</span>
          </div>
          <img
            className="radarimg"
            style={{ display: "inline-block" }}
            src={process.env.PUBLIC_URL + "/satellite/satellite5.png"}
            alt="위성사진5"
          />
        </div>
        <div>
          <div className="updatetime">
            <span>{radar_minutes["5"]}</span>
          </div>
          <img
            className="radarimg"
            style={{ display: "inline-block" }}
            src={process.env.PUBLIC_URL + "/satellite/satellite4.png"}
            alt="위성사진6"
          />
        </div>
        <div>
          <div className="updatetime">
            <span>{radar_minutes["4"]}</span>
          </div>
          <img
            className="radarimg"
            style={{ display: "inline-block" }}
            src={process.env.PUBLIC_URL + "/satellite/satellite3.png"}
            alt="위성사진7"
          />
        </div>
        <div>
          <div className="updatetime">
            <span>{radar_minutes["3"]}</span>
          </div>
          <img
            className="radarimg"
            style={{ display: "inline-block" }}
            src={process.env.PUBLIC_URL + "/satellite/satellite2.png"}
            alt="위성사진8"
          />
        </div>
        <div>
          <div className="updatetime">
            <span>{radar_minutes["2"]}</span>
          </div>
          <img
            className="radarimg"
            style={{ display: "inline-block" }}
            src={process.env.PUBLIC_URL + "/satellite/satellite1.png"}
            alt="위성사진9"
          />
        </div>
        <div>
          <div className="updatetime">
            <span>{radar_minutes["1"]}</span>
          </div>
          <img
            className="radarimg"
            style={{ display: "inline-block" }}
            src={process.env.PUBLIC_URL + "/satellite/satellite0.png"}
            alt="위성사진10"
          />
        </div>
      </Slider>
    </div>
  );
};

export default Radar1;
